const TemplateSVG = ({ fill, stroke }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 32 32"
      fill='none'
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Template">
        <path
          id="Vector"
          d="M1.33398 10.6667H29.7784M9.09156 10.6667V28M1.33398 4H29.7784V28H1.33398V4Z"
          stroke={stroke}
          stroke-width="2"
        />
      </g>
    </svg>
  );
};

export default TemplateSVG;
